import { computeAnnualPrice, computeBillingPrice } from '../../packages/utils/packagePricing';

const TAX_RATE = 0.0825;

export function getCustomPlanSubtotal(terms) {
  if (!terms) return 0;
  const billingCycle = terms.billingCycle === 'annually' ? 'annually' : 'monthly';
  return computeBillingPrice(
    terms.monthlyPrice,
    billingCycle,
    terms.annualDiscount ?? 20
  );
}

export function getCustomPlanTotals(terms) {
  const subtotal = getCustomPlanSubtotal(terms);
  const tax = subtotal * TAX_RATE;
  const grandTotal = subtotal + tax;
  return { subtotal, tax, grandTotal, taxRate: TAX_RATE };
}

export function formatBillingLabel(billingCycle) {
  return billingCycle === 'annually' ? 'year' : 'month';
}

export { computeAnnualPrice };
